import React, { Component } from "react";
import PropTypes from "prop-types";
import { Typography, FormLabel } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { withStyles } from "@mui/styles";
import FileInput from "../FileInput";
import i18n from "i18next";

const readFileAsync = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(file);
  });
};
class ImageUploader extends Component {
  initialState = {
    file: null,
    imagePreviewUrl: "",
    imagePreviewUrls:
      this.props.initialImageUrl && this.props.initialImageUrl.includes(",")
        ? this.props.initialImageUrl.split(",")
        : [],
  };

  state = { ...this.initialState };

  _onChange = async (e) => {
    const files = e.target.files;
    const fileLength = files && files.length;

    if (!fileLength) {
      console.log("No file selected.");
      return; // Exit the function early if no file is selected
    }

    if (this.props.multiple && fileLength > 1) {
      if (fileLength > 10) {
        this.props.onError && this.props.onError("Maximum 10 Files allowed");
        return;
      }
      const filePromiseArray = [...files].map(readFileAsync);
      const data = await Promise.all(filePromiseArray);
      this.setState({ files });
      this.setState({ imagePreviewUrls: data });
      return this.props.onChange(files, {});
    }

    const file = files[0];
    if (!file) {
      console.log("No file selected.");
      return; // Exit the function early if no file is selected
    }

    const reader = new window.FileReader();
    const opts = {};

    reader.onloadend = () => {
      const imagePreviewUrl = reader.result;
      this.setState({ imagePreviewUrl });
      opts.imagePreviewUrl = reader.result;
      this.props.onChange(file, opts);
    };

    reader.readAsDataURL(file);

    this.setState({ file, imagePreviewUrls: [] });
  };

  _reset() {
    this.setState(this.initialState);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.touched && !nextProps.touched) {
      this._reset();
    }
  }

  render() {
    const {
      label,
      classes,
      initialImageUrl,
      caption,
      captionStyle,
      theme,
      error,
    } = this.props;
    const { imagePreviewUrl, imagePreviewUrls } = this.state;
    const isMultiple = this.props.multiple && imagePreviewUrls.length;
    let imageUrl;
    if (imagePreviewUrl) {
      imageUrl = imagePreviewUrl;
    } else if (initialImageUrl) {
      imageUrl = initialImageUrl;
    }

    const uploadButton = (
      <FileInput
        id={this.props.buttonId}
        inputId={this.props.inputId}
        accept="image/png,image/jpg,image/jpeg"
        label={
          this.props.multiple
            ? "Upload Images"
            : i18n.t("updates_create.about_image_btn")
        }
        alt={this.props.multiple ? "Upload Images" : "Upload Image"}
        onChange={this._onChange}
        fullWidth={false}
        multiple={this.props.multiple}
      />
    );

    const inlineGap = this.props.inlineGap || 10;
    const imageContainerStyle = this.props.imageContainer || {};

    return (
      <Grid container direction="row" spacing={0.5} style={this.props.container}>
        <Grid size={{ xs: 12 }}>
          <FormLabel>{label}</FormLabel>
        </Grid>

        {caption ? (
          <Grid size={{ xs: 12 }} style={{ marginBottom: theme.spacing(1) }}>
            <Typography variant="caption" style={captionStyle}>
              {caption}
            </Typography>
          </Grid>
        ) : null}

        {isMultiple ? (
          imagePreviewUrls.map((dataImageURL) => {
            return (
              <Grid size={{ xs: 12, sm: 6 }} style={{ padding: 10 }}>
                <div className={classes.imagePreviewContainer}>
                  {dataImageURL ? (
                    <img
                      alt="Not available"
                      className={classes.imagePreview}
                      src={dataImageURL}
                    />
                  ) : null}
                </div>
              </Grid>
            );
          })
        ) : this.props.singleRowLayout ? (
          <Grid size={{ xs: 12 }}>
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: `${inlineGap}px`,
                flexWrap: "wrap",
              }}
            >
              <div
                style={{
                  ...(error ? { border: "1px solid red" } : null),
                  width: imageContainerStyle.width,
                  margin: imageContainerStyle.margin,
                  flex: "0 0 auto",
                }}
              >
                <div
                  className={classes.imagePreviewContainer}
                  style={{ ...imageContainerStyle, width: "100%", margin: 0 }}
                >
                  {imageUrl ? (
                    <img
                      className={classes.imagePreview}
                      src={imageUrl}
                      alt="Not available"
                      style={this.props.imageStyle}
                    />
                  ) : null}
                </div>
              </div>

              <div
                className={classes.buttonContainer}
                style={this.props.buttonContainer}
              >
                {uploadButton}
              </div>
            </div>
          </Grid>
        ) : (
          <Grid
            size={{ xs: 12, sm: 6 }}
            style={error ? { border: "1px solid red" } : null}
          >
            <div
              className={classes.imagePreviewContainer}
              style={this.props.imageContainer}
            >
              {imageUrl ? (
                <img
                  className={classes.imagePreview}
                  src={imageUrl}
                  alt="Not available"
                  style={this.props.imageStyle}
                />
              ) : null}
            </div>
          </Grid>
        )}

        {!this.props.singleRowLayout ? (
          <Grid
            size={{ xs: 12, sm: 6 }}
            className={classes.buttonContainer}
            style={this.props.buttonContainer}
          >
            {uploadButton}
          </Grid>
        ) : null}
      </Grid>
    );
  }
}

ImageUploader.defaultProps = {
  label: "Upload Image",
};

ImageUploader.propTypes = {
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  initialImageUrl: PropTypes.string,
  touched: PropTypes.bool,
  caption: PropTypes.string,
};

const styles = (theme) => ({
  imagePreviewContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#eeeeee",
    height: "150px",
    padding: theme.spacing(1),
  },
  imagePreview: {
    maxWidth: "100%",
    maxHeight: "100%",
  },
  filename: {
    paddingBottom: theme.spacing(1),
  },
  controlsContainer: {
    marginTop: 0,
  },
  buttonContainer: {
    paddingLeft: theme.spacing(1),
  },
});

export default withStyles(styles, { withTheme: true })(ImageUploader);
